module.exports = __webpack_public_path__ + "img/OMR.0589ecb3.svg";